import React from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import DatePicker from 'react-date-picker';
import { Link } from "react-router-dom";

import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';

import PropTypes from "prop-types";

import axios from 'axios'
import { db, sendEmail } from "firebase/fbConfig.js"
import moment from 'moment';

import Geocode from "react-geocode";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import ShipFullScreenMap from "../../views/Maps/ShipFullScreenMap";
import FormLabel from '@material-ui/core/FormLabel';
import FullScreenMap from "../../views/Maps/ShipFullScreenMap";
import NavPills from "components/NavPills/NavPills.jsx";
import FlightCard from "components/Card/FlightCard.jsx";

class Form extends React.Component {
    state = {
        comment: '',
        queryString: "",
        actionAssigned: false,
        assignedError: false,
        defaultLoaded: false,
        assigningAction: "",
        cardAnimaton: "cardHidden",
        messageSent: false,
        messageError: false,
        mapDataSaved: true
    }
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            flightNumber: "1",
            shippingMode: '',
            pickUpServices: '',
            dropOffServices: '',
            services: '',
            items: [],
            userSet: false,
            step5: true,
            item2: false,
            item3: false,
            matchingFlights: [],
            hideFlights: false,
            radius: 50,
            pickUpDate: new Date()
        };
    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
        console.log(this.state)
    }

    handleChangeICAO = (e) => {
        console.log("ICAO change");
        const { id, value } = e.target;
        this.setState({
            [id]: value.toUpperCase(),
        })
        console.log(this.state)
    }

    handlePickUpDateChange = (pickUpDate) => {
        //console.log(pickUpDate._d)
        if (pickUpDate) {
            this.setState(() => ({ pickUpDate: pickUpDate, pickUpAPI: moment(pickUpDate).format('YYYY-MM-DD') }))
        }
    }

    handleDropOffDateChange = (dropOffDate) => {
        //console.log(dropOffDate)
        if (dropOffDate) {
            this.setState(() => ({ dropOffDate: dropOffDate }))
        }
    }

    // only make future selectable  
    valid = (current) => {
        return current.isAfter(Datetime.moment().subtract(1, 'day'));
    };

    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value * 1.60934,
            pickUpDriverContactLoaded: false
        })
        // console.log(this.state)
    }



    handleSelectRadiusChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            pickUpDriverContactLoaded: false
        })
        // console.log(this.state)
    }


    handleTogglePickupServices(value) {
        const { pickUpServices } = this.state;
        const currentIndex = pickUpServices.indexOf(value);
        const newPickUpServices = [...pickUpServices];

        if (currentIndex === -1) {
            newPickUpServices.push(value);
        } else {
            newPickUpServices.splice(currentIndex, 1);
        }

        this.setState({
            pickUpServices: newPickUpServices
        });
    }

    handleToggleDropOffServices(value) {
        const { dropOffServices } = this.state;
        const currentIndex = dropOffServices.indexOf(value);
        const newDropOffServices = [...dropOffServices];

        if (currentIndex === -1) {
            newDropOffServices.push(value);
        } else {
            newDropOffServices.splice(currentIndex, 1);
        }

        this.setState({
            dropOffServices: newDropOffServices
        });
    }

    handleToggleServices(value) {
        const { services } = this.state;
        const currentIndex = services.indexOf(value);
        const newServices = [...services];

        if (currentIndex === -1) {
            newServices.push(value);
        } else {
            newServices.splice(currentIndex, 1);
        }

        this.setState({
            services: newServices
        });
    }


    handleSubmit = (e) => {
        e.preventDefault();
        // update firestore document with PENDING and comment
        db.collection("haney-orders").doc(this.state.orderData.id).set({
            flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
            originAirport: this.state.originAirport ? this.state.originAirport : null,
            destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
            driverPickUpName: this.state.driverPickUp ? this.state.driverPickUp.name : null,
            driverPickUpID: this.state.driverPickUp ? this.state.driverPickUp.id : null,
            vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
            vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
            driverDropOffName: this.state.driverDropOff ? this.state.driverDropOff.name : null,
            driverDropOffID: this.state.driverDropOff ? this.state.driverDropOff.id : null,
            vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
            vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
            status: "dispatched",
            dispatchedAt: new Date()
        }, { merge: true }).then((docRef) => {
            db.collection("TEST-users").doc(this.state.driverPickUp.id).collection("orders").doc(this.state.orderData.id).set({
                uid: this.state.uid ? this.state.uid : null,
                role: this.state.role ? this.state.role : null,
                status: "dispatched",
                driverType: "pickup",
                flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
                originAirport: this.state.originAirport ? this.state.originAirport : null,
                destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
                driverPickUpName: this.state.driverPickUp ? this.state.driverPickUp.name : null,
                driverPickUpID: this.state.driverPickUp ? this.state.driverPickUp.id : null,
                vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
                vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
                driverDropOffName: this.state.driverDropOff ? this.state.driverDropOff.name : null,
                driverDropOffID: this.state.driverDropOff ? this.state.driverDropOff.id : null,
                vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
                vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
                originBusinessName: this.state.orderData.originBusinessName ? this.state.orderData.originBusinessName : null,
                originContactName: this.state.orderData.originContactName ? this.state.orderData.originContactName : null,
                originContactEmail: this.state.orderData.originContactEmail ? this.state.orderData.originContactEmail : null,
                originContactPhone: this.state.orderData.originContactPhone ? this.state.orderData.originContactPhone : null,
                originOpenTime: this.state.orderData.originOpenTime ? this.state.orderData.originOpenTime : null,
                originCloseTime: this.state.orderData.originCloseTime ? this.state.orderData.originCloseTime : null,
                originStartTimeWindow: this.state.orderData.originStartTimeWindow ? this.state.orderData.originStartTimeWindow : null,
                originEndTimeWindow: this.state.orderData.originEndTimeWindow ? this.state.orderData.originEndTimeWindow : null,
                originAddress: this.state.orderData.originAddress ? this.state.orderData.originAddress : null,
                originCity: this.state.orderData.originCity ? this.state.orderData.originCity : null,
                originState: this.state.orderData.originState ? this.state.orderData.originState : null,
                originZip: this.state.orderData.originZip ? this.state.orderData.originZip : null,
                originType: this.state.orderData.originType ? this.state.orderData.originType : null,
                pickUpDate: this.state.orderData.pickUpDate ? this.state.orderData.pickUpDate : null,
                pickUpServices: this.state.orderData.pickUpServices ? this.state.orderData.pickUpServices : null,
                destinationBusinessName: this.state.orderData.destinationBusinessName ? this.state.orderData.destinationBusinessName : null,
                destinationContactName: this.state.orderData.destinationContactName ? this.state.orderData.destinationContactName : null,
                destinationContactEmail: this.state.orderData.destinationContactEmail ? this.state.orderData.destinationContactEmail : null,
                destinationContactPhone: this.state.orderData.destinationContactPhone ? this.state.orderData.destinationContactPhone : null,
                destinationOpenTime: this.state.orderData.destinationOpenTime ? this.state.orderData.destinationOpenTime : null,
                destinationCloseTime: this.state.orderData.destinationCloseTime ? this.state.orderData.destinationCloseTime : null,
                destinationStartTimeWindow: this.state.orderData.destinationStartTimeWindow ? this.state.orderData.destinationStartTimeWindow : null,
                destinationEndTimeWindow: this.state.orderData.destinationEndTimeWindow ? this.state.orderData.destinationEndTimeWindow : null,
                destinationAddress: this.state.orderData.destinationAddress ? this.state.orderData.destinationAddress : null,
                destinationCity: this.state.orderData.destinationCity ? this.state.orderData.destinationCity : null,
                destinationState: this.state.orderData.destinationState ? this.state.orderData.destinationState : null,
                destinationZip: this.state.orderData.destinationZip ? this.state.orderData.destinationZip : null,
                destinationType: this.state.orderData.destinationType ? this.state.orderData.destinationType : null,
                dropOffDate: this.state.orderData.dropOffDate ? this.state.orderData.dropOffDate : null,
                dropOffServices: this.state.orderData.dropOffServices ? this.state.orderData.dropOffServices : null,
                services: this.state.orderData.services ? this.state.orderData.services : null,
                unNumber: this.state.orderData.unNumber ? this.state.orderData.unNumber : null,
                properShippingName: this.state.orderData.properShippingName ? this.state.orderData.properShippingName : null,
                packaging: this.state.orderData.packaging ? this.state.orderData.packaging : null,
                quantity: this.state.orderData.quantity ? this.state.orderData.quantity : null,
                weight: this.state.orderData.weight ? this.state.orderData.weight : null,
                height: this.state.orderData.height ? this.state.orderData.height : null,
                width: this.state.orderData.width ? this.state.orderData.width : null,
                depth: this.state.orderData.depth ? this.state.orderData.depth : null,
                class: this.state.orderData.class ? this.state.orderData.class : null,
                deliveryType: this.state.orderData.deliveryType ? this.state.orderData.deliveryType : null,
                page: window.location.pathname,
                updatedAt: new Date()
            }, { merge: true }).then(() => {
                db.collection("TEST-users").doc(this.state.driverDropOff.id).collection("orders").doc(this.state.orderData.id).set({
                    uid: this.state.uid ? this.state.uid : null,
                    role: this.state.role ? this.state.role : null,
                    status: "dispatched",
                    driverType: "dropoff",
                    flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
                    originAirport: this.state.originAirport ? this.state.originAirport : null,
                    destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
                    driverPickUpName: this.state.driverPickUp ? this.state.driverPickUp.name : null,
                    driverPickUpID: this.state.driverPickUp ? this.state.driverPickUp.id : null,
                    vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
                    vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
                    driverDropOffName: this.state.driverDropOff ? this.state.driverDropOff.name : null,
                    driverDropOffID: this.state.driverDropOff ? this.state.driverDropOff.id : null,
                    vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
                    vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
                    originBusinessName: this.state.orderData.originBusinessName ? this.state.orderData.originBusinessName : null,
                    originContactName: this.state.orderData.originContactName ? this.state.orderData.originContactName : null,
                    originContactEmail: this.state.orderData.originContactEmail ? this.state.orderData.originContactEmail : null,
                    originContactPhone: this.state.orderData.originContactPhone ? this.state.orderData.originContactPhone : null,
                    originOpenTime: this.state.orderData.originOpenTime ? this.state.orderData.originOpenTime : null,
                    originCloseTime: this.state.orderData.originCloseTime ? this.state.orderData.originCloseTime : null,
                    originStartTimeWindow: this.state.orderData.originStartTimeWindow ? this.state.orderData.originStartTimeWindow : null,
                    originEndTimeWindow: this.state.orderData.originEndTimeWindow ? this.state.orderData.originEndTimeWindow : null,
                    originAddress: this.state.orderData.originAddress ? this.state.orderData.originAddress : null,
                    originCity: this.state.orderData.originCity ? this.state.orderData.originCity : null,
                    originState: this.state.orderData.originState ? this.state.orderData.originState : null,
                    originZip: this.state.orderData.originZip ? this.state.orderData.originZip : null,
                    originType: this.state.orderData.originType ? this.state.orderData.originType : null,
                    pickUpDate: this.state.orderData.pickUpDate ? this.state.orderData.pickUpDate : null,
                    pickUpServices: this.state.orderData.pickUpServices ? this.state.orderData.pickUpServices : null,
                    destinationBusinessName: this.state.orderData.destinationBusinessName ? this.state.orderData.destinationBusinessName : null,
                    destinationContactName: this.state.orderData.destinationContactName ? this.state.orderData.destinationContactName : null,
                    destinationContactEmail: this.state.orderData.destinationContactEmail ? this.state.orderData.destinationContactEmail : null,
                    destinationContactPhone: this.state.orderData.destinationContactPhone ? this.state.orderData.destinationContactPhone : null,
                    destinationOpenTime: this.state.orderData.destinationOpenTime ? this.state.orderData.destinationOpenTime : null,
                    destinationCloseTime: this.state.orderData.destinationCloseTime ? this.state.orderData.destinationCloseTime : null,
                    destinationStartTimeWindow: this.state.orderData.destinationStartTimeWindow ? this.state.orderData.destinationStartTimeWindow : null,
                    destinationEndTimeWindow: this.state.orderData.destinationEndTimeWindow ? this.state.orderData.destinationEndTimeWindow : null,
                    destinationAddress: this.state.orderData.destinationAddress ? this.state.orderData.destinationAddress : null,
                    destinationCity: this.state.orderData.destinationCity ? this.state.orderData.destinationCity : null,
                    destinationState: this.state.orderData.destinationState ? this.state.orderData.destinationState : null,
                    destinationZip: this.state.orderData.destinationZip ? this.state.orderData.destinationZip : null,
                    destinationType: this.state.orderData.destinationType ? this.state.orderData.destinationType : null,
                    dropOffDate: this.state.orderData.dropOffDate ? this.state.orderData.dropOffDate : null,
                    dropOffServices: this.state.orderData.dropOffServices ? this.state.orderData.dropOffServices : null,
                    services: this.state.orderData.services ? this.state.orderData.services : null,
                    unNumber: this.state.orderData.unNumber ? this.state.orderData.unNumber : null,
                    properShippingName: this.state.orderData.properShippingName ? this.state.orderData.properShippingName : null,
                    packaging: this.state.orderData.packaging ? this.state.orderData.packaging : null,
                    quantity: this.state.orderData.quantity ? this.state.orderData.quantity : null,
                    weight: this.state.orderData.weight ? this.state.orderData.weight : null,
                    height: this.state.orderData.height ? this.state.orderData.height : null,
                    width: this.state.orderData.width ? this.state.orderData.width : null,
                    depth: this.state.orderData.depth ? this.state.orderData.depth : null,
                    class: this.state.orderData.class ? this.state.orderData.class : null,
                    deliveryType: this.state.orderData.deliveryType ? this.state.orderData.deliveryType : null,
                    page: window.location.pathname,
                    updatedAt: new Date()
                }, { merge: true }).then(() => {
                    db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
                        status: "dispatched",
                        flightNumber: this.state.orderData.flightNumber ? this.state.orderData.flightNumber : null,
                        updatedAt: new Date()
                    }, { merge: true }).then(() => {
                        db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
                            status: "dispatched",
                            flightNumber: this.state.orderData.flightNumber ? this.state.orderData.flightNumber : null,
                            updatedAt: new Date()
                        }, { merge: true }).then(async () => {
                            console.log(this.state.pickUpDriverContact.email)
                            //const email = this.props.user.email

                            let subject = `You have been dispatched an Order!`
                            let html = `<p>Hello </p>`
                            html += `<p>Orders #: ${this.state.orderData.id}</p>`
                            // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                            const emails = [this.state.pickUpDriverContact.email]
                            const attatchment = true;
                            const emailReturn = await sendEmail({
                                emails,
                                subject,
                                html,
                                attatchment
                            })

                        }).then(() => {
                            window.location.reload()
                        })
                    })
                })
            }).catch((err) => {
                console.log(`${err}`)
            })
        }).catch((err) => {
            console.log(`${err}`)
        })
    }

    saveAsQuote = () => {
        // update firestore document with PENDING and comment
        console.log("saving quote")
        db.collection("TEST-quotes").add({
            uid: this.state.uid ? this.state.uid : null,
            role: this.state.role ? this.state.role : null,
            status: "pending",
            originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
            originContactName: this.state.originContactName ? this.state.originContactName : null,
            originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
            originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
            originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
            originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
            originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
            originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
            originAddress: this.state.originAddress ? this.state.originAddress : null,
            originCity: this.state.originCity ? this.state.originCity : null,
            originState: this.state.originState ? this.state.originState : null,
            originZip: this.state.originZip ? this.state.originZip : null,
            originType: this.state.originType ? this.state.originType : null,
            pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
            pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
            destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
            destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
            destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
            destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
            destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
            destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
            destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
            destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
            destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
            destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
            destinationState: this.state.destinationState ? this.state.destinationState : null,
            destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
            destinationType: this.state.destinationType ? this.state.destinationType : null,
            dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
            dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
            services: this.state.services ? this.state.services : null,
            unNumber: this.state.unNumber ? this.state.unNumber : null,
            properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
            packaging: this.state.packaging ? this.state.packaging : null,
            quantity: this.state.quantity ? this.state.quantity : null,
            weight: this.state.weight ? this.state.weight : null,
            height: this.state.height ? this.state.height : null,
            width: this.state.width ? this.state.width : null,
            depth: this.state.depth ? this.state.depth : null,
            class: this.state.class ? this.state.class : null,
            deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
            flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
            page: window.location.pathname,
            updatedAt: new Date()
        }).then((docRef) => {
            db.collection("TEST-users").doc(this.state.uid).collection("quotes").doc(docRef.id).set({
                uid: this.state.uid ? this.state.uid : null,
                role: this.state.role ? this.state.role : null,
                status: "pending",
                originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
                originContactName: this.state.originContactName ? this.state.originContactName : null,
                originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
                originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
                originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
                originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
                originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
                originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
                originAddress: this.state.originAddress ? this.state.originAddress : null,
                originCity: this.state.originCity ? this.state.originCity : null,
                originState: this.state.originState ? this.state.originState : null,
                originZip: this.state.originZip ? this.state.originZip : null,
                originType: this.state.originType ? this.state.originType : null,
                pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
                pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
                destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
                destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
                destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
                destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
                destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
                destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
                destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
                destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
                destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
                destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
                destinationState: this.state.destinationState ? this.state.destinationState : null,
                destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
                destinationType: this.state.destinationType ? this.state.destinationType : null,
                dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
                dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
                services: this.state.services ? this.state.services : null,
                unNumber: this.state.unNumber ? this.state.unNumber : null,
                properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
                packaging: this.state.packaging ? this.state.packaging : null,
                quantity: this.state.quantity ? this.state.quantity : null,
                weight: this.state.weight ? this.state.weight : null,
                height: this.state.height ? this.state.height : null,
                width: this.state.width ? this.state.width : null,
                depth: this.state.depth ? this.state.depth : null,
                class: this.state.class ? this.state.class : null,
                deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
                flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
                page: window.location.pathname,
                updatedAt: new Date()
            }, { merge: true }).then(() => {
                this.props.history.push('/quotes')
            }).then(() => {
                window.location.reload()
            }).catch((err) => {
                console.log(`${err}`)
            })
        }).catch((err) => {
            console.log(`${err}`)
        })
    }


    resetRequest = () => {
        window.location.reload();
    }

    setUser = (user) => {
        this.setState({
            uid: user,
            userSet: true
        })
        console.log(this.state)
    }

    handleGeoChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
        //console.log(this.state)
    }

    getFlightsByAirport = () => {
        this.setState({ matchingFlights: [], searching: true });

        const newFlights = (offset) => {

            return new Promise((resolve, reject) => {
                const axios = require('axios');
                const formattedDate = parseInt(parseInt(new Date(moment(this.state.pickUpDate).format('YYYY-MM-DD')).getTime() / 1000).toFixed(0)) + 21600;
                const endOfDay = formattedDate + 86400;

                axios({
                    'method': 'GET',
                    'url': `https://arcane-lowlands-31408.herokuapp.com/http://flightxml.flightaware.com/json/FlightXML2/AirlineFlightSchedules?origin=${this.state.originICAO}&destination=${this.state.destinationICAO}&startDate=${formattedDate}&endDate=${endOfDay}&offset=${offset}`,
                    'auth': {
                        'username': 'JustinOberg',
                        'password': '4c5c82ba4823f6ea450f4e37750b932455ae4e56'
                    }
                })
                    .then(response => {
                        const flights = [];

                        const seconds_with_leading_zeros = (dt) => {
                            return /\((.*)\)/.exec(dt.toString())[1];
                        }

                        response.data.AirlineFlightSchedulesResult.data.forEach(flight => {
                            const acToFullName = {
                                'SWA': 'Southwest Airlines',
                                'UAL': 'United Airlines'
                            }
                            const airline = acToFullName[(flight.ident.replace(/[^a-zA-Z]+/g, ''))];
                            const f = {}
                            f.aircraftType = flight.aircrafttype;
                            f.originAirport = this.state.originICAO;
                            f.destinationAirport = this.state.destinationICAO;
                            f.departureTime = new Date(flight.departuretime * 1000);
                            f.arrivalTime = new Date(flight.arrivaltime * 1000);
                            f.timezone = seconds_with_leading_zeros(f.departureTime);
                            f.number = flight.ident;
                            f.airlineName = airline;
                            flights.push(f);
                        });

                        flights.sort((a, b) => a.departureTime - b.departureTime);

                        resolve(flights);

                        // this.setState({ matchingFlights: flights, searching: false });
                    })
                    .catch(err => reject(err));
            })
        }

        Promise.all([newFlights(0), newFlights(15), newFlights(30), newFlights(45), newFlights(60), newFlights(75), newFlights(90)])
            .then((responses) => {
                const matchingFlights = [];
                for (let i = 0; i < responses.length; i++) {
                    for (let j = 0; j < responses[i].length; j++) {
                        matchingFlights.push(responses[i][j]);
                    }
                }

                this.setState({ matchingFlights: matchingFlights, searching: false })
            })
    }

    // getFlightsByAirport = () => {
    //     const axios = require('axios');
    //     this.setState({ matchingFlights: [], searching: true });
    //     const formattedDate = moment(this.state.pickUpDate).format('YYYY-MM-DD');
    //     console.log(formattedDate);

    //     axios({
    //         'method': 'GET',
    //         'url': `https://arcane-lowlands-31408.herokuapp.com/https://api.aviationstack.com/v1/flights?access_key=ca2f71a1a4173dc2f90aab592a40d6c0&dep_icao=${this.state.originICAO}&flight_date=${formattedDate}&arr_icao=${this.state.destinationICAO}`,
    //     })
    //         .then(response => {
    //             const flights = [];

    //             response.data.data.forEach(flight => {
    //                 flight.departure.scheduled = new Date(flight.departure.scheduled);
    //                 flight.arrival.scheduled = new Date(flight.arrival.scheduled);
    //                 flights.push(flight);
    //             });

    //             flights.sort((a, b) => a.departure.scheduled - b.departure.scheduled);

    //             this.setState({ matchingFlights: flights, searching: false });
    //         })
    // }


    //   getFlightsByAirport = () => {
    //     const axios = require("axios");
    //     this.setState({
    //       matchingFlights: [],
    //       searching: true
    //     })
    //     axios({
    //       "method": "GET",
    //       "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${this.state.originICAO.toUpperCase()}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T00:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T11:59`,
    //       "headers": {
    //         "content-type": "application/octet-stream",
    //         "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //         "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //       }, "params": {
    //         "withLeg": "false",
    //         "direction": "Departure"
    //       }
    //     })
    //       .then((response) => {
    //         this.setState({
    //           departingFlights: response.data,
    //         })
    //         // console.log(response.data.departures)
    //         // let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === this.state.destinationICAO));
    //         console.log(departingFlights)
    //         let filteredDepartingFlights = this.state.matchingFlights
    //         // Parse data into array like in firebase.js
    //           let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === this.state.destinationICAO.toUpperCase()));
    //           // console.log(destinationAirport)
    //           // console.log(departingFlights)
    //           if (departingFlights.length > 0) {
    //             departingFlights.forEach((flight) => {
    //               let docData = flight
    //               let docObj = {
    //                 ...docData,
    //                 originAirport: this.state.originICAO.toUpperCase()
    //               }
    //               filteredDepartingFlights.push(docObj);
    //             })
    //           }
    //         // console.log(originAirport)
    //         this.setState({
    //           earlyDepartingFlights: filteredDepartingFlights,
    //         })
    //         axios({
    //           "method": "GET",
    //           "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${this.state.originICAO.toUpperCase()}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T12:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T23:59`,
    //           "headers": {
    //             "content-type": "application/octet-stream",
    //             "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //             "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //           }, "params": {
    //             "withLeg": "false",
    //             "direction": "Departure"
    //           }
    //         })
    //           .then((response) => {
    //             this.setState({
    //               departingFlights: response.data,
    //             })
    //             // console.log(response.data.departures)
    //             // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
    //             // console.log(departingFlightsMatch)
    //             let departingFlights = this.state.earlyDepartingFlights
    //             // Parse data into array like in firebase.js
    //             let lateDepartingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === this.state.destinationICAO.toUpperCase()));
    //             console.log(this.state.earlyDepartingFlights)
    //             console.log(lateDepartingFlights)

    //             if (lateDepartingFlights.length > 0) {
    //               lateDepartingFlights.forEach((flight) => {
    //                 let docData = flight
    //                 let docObj = {
    //                   ...docData,
    //                   originAirport: this.state.originICAO.toUpperCase()
    //                 }
    //                 departingFlights.push(docObj);
    //               })
    //             }
    //             // console.log(originAirport)
    //             this.setState({
    //               matchingFlights: departingFlights,
    //               searching: false
    //             })
    //             // console.log(this.state)
    //           })
    //           .catch((error) => {
    //             console.log(error)
    //           })
    //       })
    //       .catch((error) => {
    //         console.log(error)
    //       })
    //   }

    // getFlights = () => {
    //     const axios = require('axios');
    //     this.setState({ matchingFlights: [], searching: true });
    //     Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

    //     const getCoords = (place) => {
    //         return new Promise((resolve, reject) => {
    //             Geocode.fromAddress(place)
    //                 .then(response => resolve(response.results[0].geometry.location))
    //                 .catch(err => reject(err));
    //         });
    //     }

    //     const findAirports = (coords) => {
    //         return new Promise(async (resolve, reject) => {
    //             axios({
    //                 "method": "GET",
    //                 "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${coords.lat}/${coords.lng}/km/${this.state.radius}/16`,
    //                 "headers": {
    //                     "content-type": "application/octet-stream",
    //                     "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //                     "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //                 }, "params": {
    //                     "withFlightInfoOnly": "false"
    //                 }
    //             })
    //                 .then(response => resolve(response.data))
    //                 .catch(err => reject(err));
    //         });
    //     }

    //     const getOriginAirports = () => {
    //         return new Promise(async (resolve, reject) => {
    //             const origin = ((this.props.originCity ? this.props.originCity : this.state.originCity) + " " + (this.props.originCity ? this.props.originCity : this.state.originState))
    //             const coords = await getCoords(origin);
    //             const airports = await findAirports(coords);

    //             resolve(airports)
    //         });
    //     }

    //     const getDestinationAirports = () => {
    //         return new Promise(async (resolve, reject) => {
    //             const destination = ((this.props.destinationCity ? this.props.destinationCity : this.state.destinationCity) + " " + (this.props.destinationState ? this.props.destinationState : this.state.destinationState));
    //             const coords = await getCoords(destination);
    //             const airports = await findAirports(coords);

    //             resolve(airports)
    //         });
    //     }

    //     Promise.all([getOriginAirports(), getDestinationAirports()])
    //         .then(airports => {
    //             console.log(airports);
    //             const [originAirports, destinationAirports] = airports;
    //             const getAllFlights = (originICAO, destinationICAO) => {
    //                 return new Promise((resolve, reject) => {
    //                     axios({
    //                         'method': 'GET',
    //                         'url': `https://arcane-lowlands-31408.herokuapp.com/https://api.aviationstack.com/v1/flights?access_key=ca2f71a1a4173dc2f90aab592a40d6c0&dep_icao=${originICAO}&flight_date=${moment(this.state.pickUpDate).format('YYYY-MM-DD')}&arr_icao=${destinationICAO}`,
    //                     })
    //                         .then(flights => {
    //                             console.log(flights);
    //                             resolve(flights.data);
    //                         })
    //                 })
    //             }

    //             const promises = []; // originAirports.items.map(orrAirport => destinationAirports.items.map(desAirport => getFlights(orrAirport.icao, desAirport.icao)));

    //             for (let i = 0; i < originAirports.items.length; i++) {
    //                 for (let j = 0; j < destinationAirports.items.length; j++) {
    //                     promises.push(getAllFlights(originAirports.items[i].icao, destinationAirports.items[j].icao));
    //                 }
    //             }

    //             Promise.all(promises)
    //                 .then(flightsArr => {
    //                     console.log(flightsArr);
    //                     const flights = []
    //                     for (let i = 0; i < flightsArr.length; i++) {
    //                         flightsArr[i].data.forEach(flight => {
    //                             flights.aircraft && console.log(flights.aircraft);
    //                             flight.departure.scheduled = new Date(flight.departure.scheduled);
    //                             flight.arrival.scheduled = new Date(flight.arrival.scheduled);
    //                             flights.push(flight);
    //                         });
    //                     }

    //                     flights.sort((a, b) => a.departure.scheduled - b.departure.scheduled);

    //                     console.log(flights);

    //                     this.setState({ matchingFlights: flights, searching: false })

    //                 })
    //         })
    // }

    // getFlights = () => {
    //     const axios = require("axios");
    //     console.log("getting flights")
    //     this.setState({
    //         matchingFlights: [],
    //         searching: true
    //     })

    //     Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

    //     let origin = ((this.props.originCity ? this.props.originCity : this.state.originCity) + " " + (this.props.originCity ? this.props.originCity : this.state.originState))
    //     console.log(origin)
    //     // this.setState({
    //     //   mapDataSaved: false
    //     // })
    //     let originCoords = Geocode.fromAddress(origin).then(
    //         response => {
    //             //console.log(response.results[0].geometry.location);
    //             this.setState({
    //                 originCoords: response.results[0].geometry.location,
    //             })
    //             let destination = ((this.props.destinationCity ? this.props.destinationCity : this.state.destinationCity) + " " + (this.props.destinationState ? this.props.destinationState : this.state.destinationState))
    //             console.log(destination)
    //             let destinationCoords = Geocode.fromAddress(destination).then(
    //                 response => {
    //                     // console.log(response.results[0].geometry.location);
    //                     this.setState({
    //                         destinationCoords: response.results[0].geometry.location,
    //                     })
    //                     //console.log(this.state);

    //                 }
    //             ).then(
    //                 response => {
    //                     // console.log(this.state)
    //                     axios({
    //                         "method": "GET",
    //                         "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.originCoords.lat}/${this.state.originCoords.lng}/km/${this.state.radius}/16`,
    //                         "headers": {
    //                             "content-type": "application/octet-stream",
    //                             "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //                             "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //                         }, "params": {
    //                             "withFlightInfoOnly": "false"
    //                         }
    //                     })
    //                         .then((response) => {
    //                             this.setState({
    //                                 originAirports: response.data,
    //                             })
    //                             axios({
    //                                 "method": "GET",
    //                                 "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.destinationCoords.lat}/${this.state.destinationCoords.lng}/km/${this.state.radius}/16`,
    //                                 "headers": {
    //                                     "content-type": "application/octet-stream",
    //                                     "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //                                     "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //                                 }, "params": {
    //                                     "withFlightInfoOnly": "false"
    //                                 }
    //                             })
    //                                 .then((response) => {
    //                                     this.setState({
    //                                         destinationAirports: response.data,
    //                                     })
    //                                     //console.log(this.state.originAirports.items[0].icao)

    //                                     this.state.originAirports.items.forEach((originAirport) => {
    //                                         // console.log(originAirport.icao)
    //                                         let originAirportID = originAirport.icao
    //                                         axios({
    //                                             "method": "GET",
    //                                             "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T00:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T11:59`,
    //                                             "headers": {
    //                                                 "content-type": "application/octet-stream",
    //                                                 "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //                                                 "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //                                             }, "params": {
    //                                                 "withLeg": "false",
    //                                                 "direction": "Departure"
    //                                             }
    //                                         })
    //                                             .then((response) => {
    //                                                 this.setState({
    //                                                     departingFlights: response.data,
    //                                                 })
    //                                                 console.log(response.data.departures)
    //                                                 // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
    //                                                 // console.log(departingFlightsMatch)
    //                                                 let filteredDepartingFlights = this.state.matchingFlights
    //                                                 // Parse data into array like in firebase.js
    //                                                 this.state.destinationAirports.items.forEach((destinationAirport) => {
    //                                                     let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
    //                                                     // console.log(destinationAirport)
    //                                                     // console.log(departingFlights)
    //                                                     if (departingFlights.length > 0) {
    //                                                         departingFlights.forEach((flight) => {
    //                                                             let docData = flight
    //                                                             let docObj = {
    //                                                                 ...docData,
    //                                                                 originAirport: originAirport.icao
    //                                                             }
    //                                                             filteredDepartingFlights.push(docObj);
    //                                                         })
    //                                                     }
    //                                                 })
    //                                                 console.log(originAirport)
    //                                                 this.setState({
    //                                                     matchingFlights: filteredDepartingFlights,
    //                                                 })

    //                                             })
    //                                             .catch((error) => {
    //                                                 console.log(error)
    //                                             })
    //                                     })
    //                                     this.state.originAirports.items.forEach((originAirport) => {
    //                                         // console.log(originAirport.icao)
    //                                         let originAirportID = originAirport.icao
    //                                         axios({
    //                                             "method": "GET",
    //                                             "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T12:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T23:59`,
    //                                             "headers": {
    //                                                 "content-type": "application/octet-stream",
    //                                                 "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //                                                 "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //                                             }, "params": {
    //                                                 "withLeg": "false",
    //                                                 "direction": "Departure"
    //                                             }
    //                                         })
    //                                             .then((response) => {
    //                                                 this.setState({
    //                                                     departingFlights: response.data,
    //                                                 })
    //                                                 console.log(response.data.departures)
    //                                                 // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
    //                                                 // console.log(departingFlightsMatch)
    //                                                 let filteredDepartingFlights = this.state.matchingFlights
    //                                                 // Parse data into array like in firebase.js
    //                                                 this.state.destinationAirports.items.forEach((destinationAirport) => {
    //                                                     let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
    //                                                     console.log(destinationAirport)
    //                                                     console.log(departingFlights)
    //                                                     if (departingFlights.length > 0) {
    //                                                         departingFlights.forEach((flight) => {
    //                                                             console.log(flight)
    //                                                             let docData = flight
    //                                                             let docObj = {
    //                                                                 ...docData,
    //                                                                 originAirport: originAirport.icao
    //                                                             }
    //                                                             filteredDepartingFlights.push(docObj);
    //                                                         })
    //                                                     }
    //                                                 })
    //                                                 console.log(originAirport)
    //                                                 console.log(filteredDepartingFlights)
    //                                                 this.setState({
    //                                                     matchingFlights: filteredDepartingFlights,
    //                                                     searching: false
    //                                                 })
    //                                                 console.log(this.state)
    //                                             })
    //                                             .catch((error) => {
    //                                                 console.log(error)
    //                                             })
    //                                     })
    //                                 })
    //                                 .catch((error) => {
    //                                     console.log(error)
    //                                 })
    //                             // console.log(response)
    //                         })
    //                         .catch((error) => {
    //                             console.log(error)
    //                         })

    //                 }
    //             )
    //         }
    //     )

    // }

    saveOrigin = () => {
        if (this.state.pickUpDate) {
            Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

            let origin = (this.state.originCity + " " + this.state.originState)
            console.log(origin)
            this.setState({
                mapDataSaved: false
            })
            let originCoords = Geocode.fromAddress(origin).then(
                response => {
                    console.log(response.results[0].geometry.location);
                    this.setState({
                        originCoords: response.results[0].geometry.location,
                        mapDataSaved: true,
                        step1: false,
                        step2: true

                    })
                }
            )
        }
    }

    saveDestination = () => {

        Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

        let destination = (this.state.destinationCity + " " + this.state.destinationState)
        console.log(destination)
        this.setState({
            mapDataSaved: false
        })
        let destinationCoords = Geocode.fromAddress(destination).then(
            response => {
                console.log(response.results[0].geometry.location);
                this.setState({
                    destinationCoords: response.results[0].geometry.location,
                    mapDataSaved: true,
                    step2: false,
                    step3: true

                })
            }
        )
    }

    step2Back = () => {
        this.setState({
            step1: true,
            step2: false

        })
    }

    step3Back = () => {
        this.setState({
            step2: true,
            step3: false

        })
    }

    saveFreight = () => {
        this.setState({
            step3: false,
            step4: true

        })

    }

    getQuote = () => {
        this.setState({
            step4: false,
            step5: true

        })

    }
    saveAsQuote = () => {
        this.setState({
            quote: true,

        })

    }

    step4Back = () => {
        this.setState({
            step3: true,
            step4: false

        })
    }

    step5Back = () => {
        this.setState({
            step4: true,
            step5: false

        })
    }

    addItem = () => {
        this.setState({
            item2: false
        })
    }

    addItem2 = () => {
        this.setState({
            item3: false
        })
    }

    viewFreight = () => {
        this.setState({
            viewFreight: true
        })
    }

    deliveryType = (type) => {
        this.setState({
            deliveryType: type
        })
    }

    hideFlights = () => {
        this.setState({
            hideFlights: !this.state.hideFlights
        })
    }

    addLeg = () => {
        this.setState({
            leg1: true
        })
    }

    addLeg2 = () => {
        this.setState({
            leg2: true
        })
    }

    removeLeg2 = () => {
        this.setState({
            leg1: false
        })
    }


    addLeg3 = () => {
        this.setState({
            leg3: true
        })
    }

    selectFlight = (flight) => {
        console.log("flight selected")
        this.setState({
            matchingFlights: []
        })
        this.props.onSelectFlight(flight)
    }

    selectAdditionalLegs = (flight) => {
        console.log("flight selected")
        this.setState({
            matchingFlights: []
        })
        this.props.onSelectAdditionalLegs(flight)
    }

    chooseFlight = (e) => {
        this.setState({ flightNumber: e.target.value });
    }



    loadVendorsData = (id) => {
        let data = db.collection("haney-vendors")
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    vendorsData: data,
                    vendorsDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadDriversPickUpData = (id) => {
        let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                //console.log(data)
                this.setState({
                    driversPickUpData: data,
                    driversPickUpDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadDriversDropOffData = (id) => {
        let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver')
            .get().then((snapshot) => {
                //console.log(snapshot)
                const data = []
                // Parse data into array like in firebase.js
                snapshot.forEach((doc) => {
                    var docData = doc.data()
                    var docObj = {
                        name: docData.name,
                        id: doc.id,
                    }
                    data.push(docObj);
                })
                return (data)
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(data => {
                data
                this.setState({
                    driversDropOffData: data,
                    driversDropOffDataLoaded: true,
                })
            })

        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }




    loadOrdersData = (id) => {
        console.log("loading order data")
        let data = db.collection("haney-orders").doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    orderData: docObj,
                    orderDataLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }

    loadPickUpDriverContact = (id) => {
        console.log("loading order data")
        let data = db.collection("TEST-users").doc(id)
            .get().then((snapshot) => {
                var docData = snapshot.data()
                if (docData) {
                    var docObj = {
                        ...docData,
                        id: snapshot.id,
                    }
                    return (docObj)
                } else {
                    return (null)
                }
            }, (error) => {
                console.log('error fetching data: ', error)
            }).then(docObj => {
                this.setState({
                    pickUpDriverContact: docObj,
                    pickUpDriverContactLoaded: true
                })
            })
        //console.log(this.state)
        //let relatedConceptsData = this.props.relatedConcepts.dataRows

        // this.setState({
        //   relatedConceptsData,
        //   dataLoaded: true
        // })
    }


    render() {
        const { classes, modalClose, orderID, authUser, user } = this.props;
        // Inspired by blueprintjs
        function StyledRadio(props) {

            return (
                <Radio
                    className={classes.root}
                    disableRipple
                    color="default"
                    checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                    icon={<span className={classes.icon} />}
                    {...props}
                />
            );
        }
        radiusOptions
        const shippingModes = ['', 'LTL', 'TL']
        const role = ['', 'Shipper', 'Consignee', 'Third Party']
        const locationTypes = ['', 'Business', 'Construction Site', 'Convention Center or Tradeshow', 'Freight Carrier Terminal', 'Home Based Business', 'Mlitary Base', 'Mini-Storage / Self Storage Facility', 'Religious Institution', 'Residential / Home']
        const packagingTypes = ['', 'Pallets: Standard (40" x 48")', 'Pallets (48" x 48")', 'Pallets (60" x 48")', 'Pallets (enter dimensions)', 'Boxed', 'Crated', 'Drums or Barrels']
        const freightClass = ['', 'I dont know', '50', '55', '60', '65', '70', '77.5', '85', '92.5', '100', '110', '125', '150', '175', '200', '250', '300', '400', '500']
        const radiusOptions = ['', '50', '100', '150', '200', '250', '300']

        if (authUser && !this.state.userSet) { this.setUser(authUser.uid) }
        //console.log(authUser)
        // reset modal when closed
        if (this.state.messageSent) { this.resetRequest() }

        let pathname = window.location.pathname
        console.log(this.state)
        console.log(this.props)

        if (user.dataLoaded
            && !this.state.orderDataLoaded && !this.state.vendorsDataLoaded && orderID) {
            this.loadOrdersData(orderID)
            this.loadVendorsData()
        }

        if (this.state.vendorPickUp && !this.state.driversPickUpDataLoaded) {
            this.loadDriversPickUpData(this.state.vendorPickUp.id)
        }

        if (this.state.vendorDropOff && !this.state.driversDropOffDataLoaded) {
            this.loadDriversDropOffData(this.state.vendorDropOff.id)
        }

        if (this.state.driverPickUp && !this.state.pickUpDriverContactLoaded) {
            this.loadPickUpDriverContact(this.state.driverPickUp.id)
        }

        console.log(this.state);
        console.log(this.props);

        return (
            <div>
                {this.state.messageSent ? (
                    <GridContainer justify="center">
                        <GridItem xs={11}>
                            <h4 className={classes.textPrimary}>Order Submitted!</h4>

                        </GridItem>
                    </GridContainer>
                ) : (
                    <GridContainer style={{ marginTop: "-30px" }} justify="center">
                        {/* {
                this.state.mapDataSaved ?
                  <GridItem xs={12} md={8}>
                    <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                  </GridItem>
                  : null
              } */}
                        <GridItem xs={12}>
                            <div className={classes.formContainer}>
                                <form onSubmit={this.handleSubmit}
                                >
                                    <GridContainer justify="center">
                                        <GridItem xs={11}>
                                            {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error: {this.state.messageError}</h5> : null}
                                            {this.state.step1 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 1 of 4</h3>
                                                    <p>Tell us who you are and where you're coming from.</p>
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="role"
                                                            className={classes.selectLabel}>
                                                            YOUR ROLE:
                          </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.role}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'role',
                                                                name: 'role'
                                                            }}
                                                        >
                                                            {
                                                                role.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/*<FormControl
                          fullWidth
                          className={classes.selectFormControl}>
                          <InputLabel
                            htmlFor="shippingmode"
                            className={classes.selectLabel}>
                            SHIPPING MODE:
                  </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.shippingMode}
                            onChange={this.handleSelectChange}
                            inputProps={{
                              id: 'shippingMode',
                              name: 'shippingMode'
                            }}
                          >
                            {
                              shippingModes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                  value={item}
                                  key={item}
                                >{item}</MenuItem>
                              ))
                            }
                          </Select>
                          </FormControl>*/}

                                                    <br />
                                                    <br />
                                                    <h4 className={classes.bodyText}><b>Origin Details</b></h4>

                                                    <CustomInput
                                                        labelText="Business Name"
                                                        id="originBusinessName"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.originBusinessName ? this.state.originBusinessName : ''
                                                        }}
                                                    />

                                                    <CustomInput
                                                        labelText="Address"
                                                        id="originAddress"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.originAddress ? this.state.originAddress : ''
                                                        }}
                                                    />
                                                    <GridContainer justify="center">
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="City"
                                                                id="originCity"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originCity ? this.state.originCity : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3} style={{ padding: "0px, 0px, 0px, 0px !important" }}>
                                                            <CustomInput
                                                                labelText="State"
                                                                id="originState"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originState ? this.state.originState : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3}>
                                                            <CustomInput
                                                                labelText="ZIP"
                                                                id="originZip"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originZip ? this.state.originZip : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="originType"
                                                                    className={classes.selectLabel}>
                                                                    LOCATION TYPE:
                          </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.originType}
                                                                    onChange={this.handleSelectChange}
                                                                    defaultValue={this.state.originZip ? this.state.originZip : ''}
                                                                    inputProps={{
                                                                        id: 'originType',
                                                                        name: 'originType'
                                                                    }}
                                                                >
                                                                    {
                                                                        locationTypes.map((item) => (
                                                                            <MenuItem
                                                                                classes={{
                                                                                    root: classes.selectMenuItem
                                                                                }}
                                                                                value={item}
                                                                                key={item}
                                                                            >{item}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </GridItem>
                                                    </GridContainer>
                                                    <GridContainer style={{ marginTop: "10px" }}>
                                                        <GridItem xs={6}>
                                                            <Datetime
                                                                selected={this.state.pickUpDate}
                                                                onChange={this.handlePickUpDateChange}
                                                                defaultValue={this.state.pickUpDate ? this.state.pickUpDate : ''}
                                                                timeFormat={true}
                                                                isValidDate={this.valid}
                                                                renderInput={(dateInputProps, open, close) => (
                                                                    <CustomInput
                                                                        inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                                                                        onBlur={close}
                                                                        onFocus={open}
                                                                        labelText="Pickup Date"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                    />
                                                                )}
                                                            />

                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleTogglePickupServices('Lift Gate')}
                                                                            checked={this.state.pickUpServices.indexOf('Lift Gate') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Lift Gate at Pickup Point'
                                                                />
                                                            </div><br />
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleTogglePickupServices('Limited Access')}
                                                                            checked={this.state.pickUpServices.indexOf('Limited Access') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Limited Access Pick Up'
                                                                />
                                                            </div>

                                                        </GridItem>
                                                    </GridContainer>

                                                    <Button
                                                        style={{ float: "right", marginTop: "20px" }}
                                                        color="primary"
                                                        onClick={() => this.saveOrigin()}
                                                    >NEXT</Button>
                                                </div>
                                                : null}

                                            {/* 
                        <CustomInput
                          labelText="Notes"
                          id="description"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            id: "pickUpNotes",
                            name: "pickUpNotes",
                            type: "text",
                            multiline: true,
                            rows: 5,
                            onChange: (event) => this.handleChange(event)
                          }}
                        /> */}

                                            {this.state.step2 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 2 of 4</h3>
                                                    <p>Tell us where you're going.</p>

                                                    <h4 className={classes.bodyText}><b>Receiver Details</b></h4>

                                                    <CustomInput
                                                        labelText="Business Name"
                                                        id="destinationBusinessName"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.destinationBusinessName ? this.state.destinationBusinessName : ''
                                                        }}
                                                    />

                                                    <CustomInput
                                                        labelText="Address"
                                                        id="destinationAddress"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "text",
                                                            onChange: (event) => this.handleChange(event),
                                                            defaultValue: this.state.destinationAddress ? this.state.destinationAddress : ''
                                                        }}
                                                    />
                                                    <GridContainer justify="center">
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="City"
                                                                id="destinationCity"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationCity ? this.state.destinationCity : ''

                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3} style={{ padding: "0px, 0px, 0px, 0px !important" }}>
                                                            <CustomInput
                                                                labelText="State"
                                                                id="destinationState"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationState ? this.state.destinationState : ''

                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={3}>
                                                            <CustomInput
                                                                labelText="ZIP"
                                                                id="destinationZip"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationZip ? this.state.destinationZip : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>

                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="destinationType"
                                                            className={classes.selectLabel}>
                                                            LOCATION TYPE:
                    </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.destinationType}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'destinationType',
                                                                name: 'destinationType'
                                                            }}
                                                        >
                                                            {
                                                                locationTypes.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    <GridContainer style={{ marginTop: "10px" }}>
                                                        <GridItem xs={6}>
                                                            <Datetime
                                                                selected={this.state.dropOffDate}
                                                                onChange={this.handleDropOffDateChange}
                                                                defaultValue={this.state.dropOffDate ? this.state.dropOffDate : ''}
                                                                timeFormat={true}
                                                                isValidDate={this.valid}
                                                                renderInput={(dateInputProps, open, close) => (
                                                                    <CustomInput
                                                                        inputProps={{ ...dateInputProps, id: 'dropOffDate', name: 'dropOffDate', required: true, }}
                                                                        onBlur={close}
                                                                        onFocus={open}
                                                                        labelText="Drop Off Date"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                    />
                                                                )}
                                                            />

                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleDropOffServices('Lift Gate')}
                                                                            checked={this.state.dropOffServices.indexOf('Lift Gate') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Lift Gate at Pickup Point'
                                                                />
                                                            </div><br />
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleDropOffServices('Limited Access')}
                                                                            checked={this.state.dropOffServices.indexOf('Limited Access') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Limited Access Pick Up'
                                                                />
                                                            </div>

                                                        </GridItem>

                                                    </GridContainer>
                                                    <GridContainer>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ marginTop: "20px" }}
                                                                onClick={() => this.step2Back()}
                                                            >BACK</Button>
                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ float: "right", marginTop: "20px" }}
                                                                onClick={() => this.saveDestination()}
                                                            >NEXT</Button>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                : null}

                                            {/* <CustomInput
                              labelText="Notes"
                              id="dropOffNotes"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: "text",
                                multiline: true,
                                rows: 5,
                                onChange: (event) => this.handleChange(event)
                              }}
                            /> */}
                                            {this.state.step3 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 3 of 4</h3>
                                                    <p>Tell us who we'll be dealing with and when.</p>
                                                    <p><b>Who can we contact at the origin address?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Name"
                                                                id="originContactName"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originContactName ? this.state.originContactName : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Email"
                                                                id="originContactEmail"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originContactEmail ? this.state.originContactEmail : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Phone"
                                                                id="originContactPhone"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originContactPhone ? this.state.originContactPhone : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>

                                                    <p><b>What are their business hours?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Open"
                                                                id="originOpenTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originOpenTime ? this.state.originOpenTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={2}>
                                                            <p>to</p>
                                                        </GridItem>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Close"
                                                                id="originCloseTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originCloseTime ? this.state.originCloseTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <p><b>When should we pick up the freight?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={2}>
                                                            <p>Between</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="Start"
                                                                id="originStartTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={1}>
                                                            <p>and</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="End"
                                                                id="originEndTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <br /> <br />
                                                    <p><b>Who can we contact at the destination address?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Name"
                                                                id="destinationContactName"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationContactName ? this.state.destinationContactName : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Email"
                                                                id="destinationContactEmail"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationContactEmail ? this.state.destinationContactEmail : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={12}>
                                                            <CustomInput
                                                                labelText="Contact Phone"
                                                                id="destinationContactPhone"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationContactPhone ? this.state.destinationContactPhone : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>

                                                    <p><b>What are their business hours?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Open"
                                                                id="destinationOpenTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationOpenTime ? this.state.destinationOpenTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={2}>
                                                            <p>to</p>
                                                        </GridItem>
                                                        <GridItem xs={5}>
                                                            <CustomInput
                                                                labelText="Close"
                                                                id="destinationCloseTime"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationCloseTime ? this.state.destinationCloseTime : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <p><b>When should we drop off the freight?</b></p>
                                                    <GridContainer>
                                                        <GridItem xs={2}>
                                                            <p>Between</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="Start"
                                                                id="destinationStartTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={1}>
                                                            <p>and</p>
                                                        </GridItem>
                                                        <GridItem xs={4}>
                                                            <CustomInput
                                                                labelText="End"
                                                                id="destinationEndTimeWindow"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <GridContainer>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ marginTop: "20px" }}
                                                                onClick={() => this.step3Back()}
                                                            >BACK</Button>
                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <Button
                                                                color="primary"
                                                                style={{ float: "right", marginTop: "20px" }}
                                                                onClick={() => this.saveFreight()}
                                                            >NEXT</Button>
                                                        </GridItem>
                                                    </GridContainer>
                                                </div>
                                                : null}
                                            {this.state.step4 ?
                                                <div>
                                                    <h3 className={classes.bodyText}>Step 4 of 4</h3>
                                                    <p>Tell us what you are shipping.</p>





                                                    <h3 className={classes.bodyText}>ITEM #1</h3>
                                                    <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    onClick={() => this.handleToggleServices('Hazmat')}
                                                                    checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                                    color="primary"
                                                                    classes={{
                                                                        checked: classes.checked,
                                                                        root: classes.checkRoot
                                                                    }}
                                                                />
                                                            }
                                                            classes={{ label: classes.bodyText }}
                                                            label='Hazmat'
                                                        />
                                                    </div>
                                                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    tabIndex={-1}
                                                                    onClick={() => this.handleToggleServices('Over Length')}
                                                                    checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                                    color="primary"
                                                                    classes={{
                                                                        checked: classes.checked,
                                                                        root: classes.checkRoot
                                                                    }}
                                                                />
                                                            }
                                                            classes={{ label: classes.bodyText }}
                                                            label='Over Length'
                                                        />
                                                    </div>
                                                    <GridContainer>
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="UN Number"
                                                                id="unNumber"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.unNumber ? this.state.unNumber : ''

                                                                }}
                                                            />

                                                        </GridItem>
                                                        <GridItem xs={6}>
                                                            <CustomInput
                                                                labelText="Proper Shipping Name"
                                                                id="properShippingName"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "text",
                                                                    onChange: (event) => this.handleChange(event),
                                                                    defaultValue: this.state.properShippingName ? this.state.properShippingName : ''
                                                                }}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="packaging"
                                                            className={classes.selectLabel}>
                                                            PACKAGING:
                </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.packaging}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'packaging',
                                                                name: 'packaging'
                                                            }}
                                                        >
                                                            {
                                                                packagingTypes.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>


                                                    <CustomInput
                                                        labelText="Qty"
                                                        id="quantity"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "number",
                                                            min: "0",
                                                            step: "1",
                                                            onChange: (event) => this.handleChange(event)
                                                        }}
                                                    />
                                                    <CustomInput
                                                        labelText="Total Weight"
                                                        id="weight"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            required: true,
                                                            type: "number",
                                                            min: "0",
                                                            step: "1",
                                                            onChange: (event) => this.handleChange(event)
                                                        }}
                                                    />
                                                    {
                                                        this.state.packaging == "Pallets (enter dimensions)" ?
                                                            <GridContainer>
                                                                <GridItem xs={3}>
                                                                    <CustomInput
                                                                        labelText="Height"
                                                                        id="height"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event),
                                                                            defaultValue: this.state.height ? this.state.height : ''
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                                <GridItem xs={4}>
                                                                    <CustomInput
                                                                        labelText="Width"
                                                                        id="width"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event),
                                                                            defaultValue: this.state.width ? this.state.width : ''
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                                <GridItem xs={3}>
                                                                    <CustomInput
                                                                        labelText="Depth"
                                                                        id="depth"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event),
                                                                            defaultValue: this.state.depth ? this.state.depth : ''
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            : null
                                                    }

                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="class"
                                                            className={classes.selectLabel}>
                                                            FREIGHT CLASS:
            </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.class}
                                                            onChange={this.handleSelectChange}
                                                            inputProps={{
                                                                id: 'class',
                                                                name: 'class'
                                                            }}
                                                        >
                                                            {
                                                                freightClass.map((item) => (
                                                                    <MenuItem
                                                                        classes={{
                                                                            root: classes.selectMenuItem
                                                                        }}
                                                                        value={item}
                                                                        key={item}
                                                                    >{item}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {!this.state.item2 ?
                                                        <Button
                                                            color="primary"
                                                            onClick={() => this.addItem()}
                                                        >
                                                            ADD ITEM
                       </Button>
                                                        : null}
                                                    {this.state.item2 ?
                                                        <div>
                                                            <h3 className={classes.bodyText}>ITEM #2</h3>
                                                            <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleServices('Hazmat')}
                                                                            checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Hazmat'
                                                                />
                                                            </div>
                                                            <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            tabIndex={-1}
                                                                            onClick={() => this.handleToggleServices('Over Length')}
                                                                            checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                                            color="primary"
                                                                            classes={{
                                                                                checked: classes.checked,
                                                                                root: classes.checkRoot
                                                                            }}
                                                                        />
                                                                    }
                                                                    classes={{ label: classes.bodyText }}
                                                                    label='Over Length'
                                                                />
                                                            </div>
                                                            <GridContainer>
                                                                <GridItem xs={6}>
                                                                    <CustomInput
                                                                        labelText="UN Number"
                                                                        id="unNumber"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "number",
                                                                            min: "0",
                                                                            step: "1",
                                                                            onChange: (event) => this.handleChange(event)
                                                                        }}
                                                                    />

                                                                </GridItem>
                                                                <GridItem xs={6}>
                                                                    <CustomInput
                                                                        labelText="Proper Shipping Name"
                                                                        id="propperShippingName"
                                                                        formControlProps={{
                                                                            fullWidth: true
                                                                        }}
                                                                        inputProps={{
                                                                            required: true,
                                                                            type: "text",
                                                                            onChange: (event) => this.handleChange(event)
                                                                        }}
                                                                    />
                                                                </GridItem>
                                                            </GridContainer>
                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="packaging"
                                                                    className={classes.selectLabel}>
                                                                    PACKAGING:
                </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.packaging}
                                                                    onChange={this.handleSelectChange}
                                                                    inputProps={{
                                                                        id: 'packaging',
                                                                        name: 'packaging'
                                                                    }}
                                                                >
                                                                    {
                                                                        packagingTypes.map((item) => (
                                                                            <MenuItem
                                                                                classes={{
                                                                                    root: classes.selectMenuItem
                                                                                }}
                                                                                value={item}
                                                                                key={item}
                                                                            >{item}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>


                                                            <CustomInput
                                                                labelText="Qty"
                                                                id="quantity"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "number",
                                                                    min: "0",
                                                                    step: "1",
                                                                    onChange: (event) => this.handleChange(event)
                                                                }}
                                                            />
                                                            <CustomInput
                                                                labelText="Total Weight"
                                                                id="weight"
                                                                formControlProps={{
                                                                    fullWidth: true
                                                                }}
                                                                inputProps={{
                                                                    required: true,
                                                                    type: "number",
                                                                    min: "0",
                                                                    step: "1",
                                                                    onChange: (event) => this.handleChange(event)
                                                                }}
                                                            />
                                                            {
                                                                this.state.packaging == "Pallets (enter dimensions)" ?
                                                                    <GridContainer>
                                                                        <GridItem xs={3}>
                                                                            <CustomInput
                                                                                labelText="Height"
                                                                                id="height"
                                                                                formControlProps={{
                                                                                    fullWidth: true
                                                                                }}
                                                                                inputProps={{
                                                                                    required: true,
                                                                                    type: "number",
                                                                                    min: "0",
                                                                                    step: "1",
                                                                                    onChange: (event) => this.handleChange(event)
                                                                                }}
                                                                            />
                                                                        </GridItem>
                                                                        <GridItem xs={4}>
                                                                            <CustomInput
                                                                                labelText="Width"
                                                                                id="width"
                                                                                formControlProps={{
                                                                                    fullWidth: true
                                                                                }}
                                                                                inputProps={{
                                                                                    required: true,
                                                                                    type: "number",
                                                                                    min: "0",
                                                                                    step: "1",
                                                                                    onChange: (event) => this.handleChange(event)
                                                                                }}
                                                                            />
                                                                        </GridItem>
                                                                        <GridItem xs={3}>
                                                                            <CustomInput
                                                                                labelText="Depth"
                                                                                id="depth"
                                                                                formControlProps={{
                                                                                    fullWidth: true
                                                                                }}
                                                                                inputProps={{
                                                                                    required: true,
                                                                                    type: "number",
                                                                                    min: "0",
                                                                                    step: "1",
                                                                                    onChange: (event) => this.handleChange(event)
                                                                                }}
                                                                            />
                                                                        </GridItem>
                                                                    </GridContainer>
                                                                    : null
                                                            }

                                                            <FormControl
                                                                fullWidth
                                                                className={classes.selectFormControl}>
                                                                <InputLabel
                                                                    htmlFor="class"
                                                                    className={classes.selectLabel}>
                                                                    FREIGHT CLASS:
            </InputLabel>
                                                                <Select
                                                                    MenuProps={{
                                                                        className: classes.selectMenu
                                                                    }}
                                                                    classes={{
                                                                        select: classes.select
                                                                    }}
                                                                    value={this.state.class}
                                                                    onChange={this.handleSelectChange}
                                                                    inputProps={{
                                                                        id: 'class',
                                                                        name: 'class'
                                                                    }}
                                                                >
                                                                    {
                                                                        freightClass.map((item) => (
                                                                            <MenuItem
                                                                                classes={{
                                                                                    root: classes.selectMenuItem
                                                                                }}
                                                                                value={item}
                                                                                key={item}
                                                                            >{item}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </div>
                                                        : null}


                                                    {this.state.flights && this.state.flights.map(flight => {
                                                        if (flight.Stops.length == 0) {
                                                            return (
                                                                <div>
                                                                    <Card style={{ backgroundColor: "white", boxShadow: "0px 0px 5px 0px #888888" }}>
                                                                        {/* <CardHeader>
                          <h5 style={{ color: "black" }}> <i>Case #{flight.id}</i> <br /></h5>
                        </CardHeader> */}
                                                                        <CardBody>
                                                                            <p><span style={{ color: "black" }}>Carrier:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Carriers}</span> </p>
                                                                            {/*<p><span style={{ color: "black" }}>Stops:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Stops.length}</span> </p>
                          <p>Flights: {flight.FlightNumbers.map(flight => {
                            return (
                              <p>
                                {flight.FlightNumber} <br />{flight.CarrierId}
                              </p>
                            )
                          })}</p>*/}
                                                                            <GridContainer>
                                                                                <GridItem xs={6}>
                                                                                    {String(flight.Departure)}
                                                                                </GridItem>
                                                                                <GridItem xs={6}>
                                                                                    {String(flight.Arrival)}
                                                                                </GridItem>
                                                                            </GridContainer>
                                                                        </CardBody>

                                                                    </Card>
                                                                </div>
                                                            )
                                                        } else {
                                                            null
                                                        }
                                                    })}
                                                    {this.state.assigningAction ? (
                                                        <div>
                                                            <p className={classes.bodyText}>{this.state.assigningAction}</p>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <GridContainer>
                                                                <GridItem xs={6}>
                                                                    <Button
                                                                        color="primary"
                                                                        style={{ marginTop: "20px" }}
                                                                        onClick={() => this.step4Back()}
                                                                    >BACK</Button>
                                                                </GridItem>
                                                                <GridItem xs={6}>
                                                                    <Button
                                                                        color="primary"
                                                                        style={{ float: "right", marginTop: "20px" }}
                                                                        onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                                                    >NEXT</Button>
                                                                </GridItem>
                                                            </GridContainer>

                                                        </div>

                                                    )}


                                                </div>

                                                : null}
                                            {this.state.step5 ?
                                                <div>
                                                    <br />
                                                    <GridContainer>
                                                        <GridItem xs={12}>
                                                            {(pathname == "/completed-orders") ? null :
                                                                <div>


                                                                    <br />
                                                                    <GridContainer>
                                                                        {/* <GridItem xs={12} md={4}>
                                        <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                                      </GridItem> <br /> */}
                                                                        <GridItem xs={12}>
                                                                            <GridContainer>
                                                                                <GridItem xs={12}>
                                                                                    <FormControl component='fieldset' style={{ width: '100%' }}>
                                                                                        <RadioGroup
                                                                                            row
                                                                                            defaultValue='1'
                                                                                            onChange={this.chooseFlight}
                                                                                            style={{
                                                                                                display: 'flex',
                                                                                                justifyContent: 'space-between',
                                                                                                // width: '100%'
                                                                                            }}
                                                                                        >
                                                                                            <FormControlLabel
                                                                                                value='1'
                                                                                                control={<Radio color='secondary' />}
                                                                                                label='Flight 1'
                                                                                                labelPlacement='start'
                                                                                            />
                                                                                            <FormControlLabel
                                                                                                value='2'
                                                                                                control={<Radio color='secondary' />}
                                                                                                label='Flight 2'
                                                                                                labelPlacement='start'
                                                                                            />
                                                                                        </RadioGroup>
                                                                                    </FormControl>
                                                                                </GridItem>
                                                                                <GridItem xs={12}>
                                                                                    Search Flights:
                                            <GridContainer>
                                                                                        <GridItem xs={6}>

                                                                                            <DatePicker
                                                                                                onChange={this.handlePickUpDateChange}
                                                                                                value={this.state.pickUpDate ? this.state.pickUpDate : ''}
                                                                                            />
                                                                                        </GridItem>
                                                                                        <GridItem xs={6}>
                                                                                            <FormControl
                                                                                                fullWidth
                                                                                                className={classes.selectFormControl}>
                                                                                                <InputLabel
                                                                                                    htmlFor="radius"
                                                                                                    className={classes.selectLabel}>
                                                                                                    Radius:
                          </InputLabel>
                                                                                                <Select
                                                                                                    MenuProps={{
                                                                                                        className: classes.selectMenu
                                                                                                    }}
                                                                                                    classes={{
                                                                                                        select: classes.select
                                                                                                    }}
                                                                                                    value={this.state.radius}
                                                                                                    onChange={this.handleSelectRadiusChange}
                                                                                                    defaultValue={this.state.radius ? this.state.radius : ''}
                                                                                                    inputProps={{
                                                                                                        id: 'radius',
                                                                                                        name: 'radius'
                                                                                                    }}
                                                                                                >
                                                                                                    {
                                                                                                        radiusOptions.map((item) => (
                                                                                                            <MenuItem
                                                                                                                classes={{
                                                                                                                    root: classes.selectMenuItem
                                                                                                                }}
                                                                                                                value={item}
                                                                                                                key={item}
                                                                                                            >{item}</MenuItem>
                                                                                                        ))
                                                                                                    }
                                                                                                </Select>
                                                                                            </FormControl>

                                                                                        </GridItem>
                                                                                        <NavPills
                                                                                            color="primary"
                                                                                            alignCenter
                                                                                            tabs={[
                                                                                                //                                                                 {
                                                                                                //                                                                     tabButton: "City",
                                                                                                //                                                                     //tabIcon: Info,
                                                                                                //                                                                     tabContent: (
                                                                                                //                                                                         <div>
                                                                                                //                                                                             <GridContainer>
                                                                                                //                                                                                 <GridItem xs={6}>
                                                                                                //                                                                                     <CustomInput
                                                                                                //                                                                                         labelText="Starting City"
                                                                                                //                                                                                         id="originCity"
                                                                                                //                                                                                         formControlProps={{
                                                                                                //                                                                                             fullWidth: true
                                                                                                //                                                                                         }}
                                                                                                //                                                                                         inputProps={{
                                                                                                //                                                                                             required: false,
                                                                                                //                                                                                             type: "text",
                                                                                                //                                                                                             onChange: (event) => this.handleChange(event),
                                                                                                //                                                                                             defaultValue: this.props.originCity ? this.props.originCity : (this.state.originCity ? this.state.origioriginCitynZip : '')
                                                                                                //                                                                                         }}
                                                                                                //                                                                                     />
                                                                                                //                                                                                 </GridItem>
                                                                                                //                                                                                 <GridItem xs={6}>
                                                                                                //                                                                                     <CustomInput
                                                                                                //                                                                                         labelText="Starting State"
                                                                                                //                                                                                         id="originState"
                                                                                                //                                                                                         formControlProps={{
                                                                                                //                                                                                             fullWidth: true
                                                                                                //                                                                                         }}
                                                                                                //                                                                                         inputProps={{
                                                                                                //                                                                                             required: false,
                                                                                                //                                                                                             type: "text",
                                                                                                //                                                                                             onChange: (event) => this.handleChange(event),
                                                                                                //                                                                                             defaultValue: this.props.originState ? this.props.originState : (this.state.originState ? this.state.originState : '')
                                                                                                //                                                                                         }}
                                                                                                //                                                                                     />

                                                                                                //                                                                                 </GridItem>
                                                                                                //                                                                                 <GridItem xs={6}>
                                                                                                //                                                                                     <CustomInput
                                                                                                //                                                                                         labelText="Ending City"
                                                                                                //                                                                                         id="destinationCity"
                                                                                                //                                                                                         formControlProps={{
                                                                                                //                                                                                             fullWidth: true
                                                                                                //                                                                                         }}
                                                                                                //                                                                                         inputProps={{
                                                                                                //                                                                                             required: false,
                                                                                                //                                                                                             type: "text",
                                                                                                //                                                                                             onChange: (event) => this.handleChange(event),
                                                                                                //                                                                                             defaultValue: this.props.destinationCity ? this.props.destinationCity : (this.state.destinationCity ? this.state.destinationCity : '')
                                                                                                //                                                                                         }}
                                                                                                //                                                                                     />

                                                                                                //                                                                                 </GridItem>
                                                                                                //                                                                                 <GridItem xs={6}>
                                                                                                //                                                                                     <CustomInput
                                                                                                //                                                                                         labelText="Ending State"
                                                                                                //                                                                                         id="destinationState"
                                                                                                //                                                                                         formControlProps={{
                                                                                                //                                                                                             fullWidth: true
                                                                                                //                                                                                         }}
                                                                                                //                                                                                         inputProps={{
                                                                                                //                                                                                             required: false,
                                                                                                //                                                                                             type: "text",
                                                                                                //                                                                                             onChange: (event) => this.handleChange(event),
                                                                                                //                                                                                             defaultValue: this.props.destinationState ? this.props.destinationState : (this.state.destinationState ? this.state.destinationState : '')
                                                                                                //                                                                                         }}
                                                                                                //                                                                                     />

                                                                                                //                                                                                 </GridItem>
                                                                                                //                                                                                 <GridItem xs={6}>
                                                                                                //                                                                                     {this.state.pickUpDate &&
                                                                                                //                                                                                         <Button
                                                                                                //                                                                                             color="primary"
                                                                                                //                                                                                             onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                                                                                //                                                                                         >
                                                                                                //                                                                                             SEARCH FLIGHTS
                                                                                                //           </Button>
                                                                                                //                                                                                     }


                                                                                                //                                                                                 </GridItem>
                                                                                                //                                                                                 <GridItem xs={6}>
                                                                                                //                                                                                     <Button
                                                                                                //                                                                                         color="info"
                                                                                                //                                                                                         onClick={() => this.hideFlights()}
                                                                                                //                                                                                     >
                                                                                                //                                                                                         {this.state.hideFlights ? "SHOW" : "HIDE"} FLIGHTS
                                                                                                //   </Button>
                                                                                                //                                                                                 </GridItem>
                                                                                                //                                                                             </GridContainer>

                                                                                                //                                                                         </div>
                                                                                                //                                                                     )
                                                                                                //                                                                 },
                                                                                                {
                                                                                                    tabButton: "Airport",
                                                                                                    //tabIcon: LocationOn,
                                                                                                    tabContent: (
                                                                                                        <div>
                                                                                                            <GridContainer>
                                                                                                                <GridItem xs={6}>
                                                                                                                    <CustomInput
                                                                                                                        labelText="Starting ICAO"
                                                                                                                        id="originICAO"
                                                                                                                        formControlProps={{
                                                                                                                            fullWidth: true
                                                                                                                        }}
                                                                                                                        inputProps={{
                                                                                                                            required: false,
                                                                                                                            type: "text",
                                                                                                                            onChange: (event) => this.handleChangeICAO(event),
                                                                                                                            value: this.state.originICAO ? this.state.originICAO : ''
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </GridItem>
                                                                                                                <GridItem xs={6}>
                                                                                                                    <CustomInput
                                                                                                                        labelText="Ending ICAO"
                                                                                                                        id="destinationICAO"
                                                                                                                        formControlProps={{
                                                                                                                            fullWidth: true
                                                                                                                        }}
                                                                                                                        inputProps={{
                                                                                                                            required: false,
                                                                                                                            type: "text",
                                                                                                                            onChange: (event) => this.handleChangeICAO(event),
                                                                                                                            value: this.state.destinationICAO ? this.state.destinationICAO : ''
                                                                                                                        }}
                                                                                                                    />

                                                                                                                </GridItem>
                                                                                                                <GridItem xs={6}>
                                                                                                                    {this.state.pickUpDate &&
                                                                                                                        <Button
                                                                                                                            color="primary"
                                                                                                                            onClick={() => this.getFlightsByAirport()}
                                                                                                                        >
                                                                                                                            SEARCH FLIGHTS
                                              </Button>
                                                                                                                    }


                                                                                                                </GridItem>
                                                                                                                <GridItem xs={6}>
                                                                                                                    <Button
                                                                                                                        color="info"
                                                                                                                        onClick={() => this.hideFlights()}
                                                                                                                    >
                                                                                                                        {this.state.hideFlights ? "SHOW" : "HIDE"} FLIGHTS
                                      </Button>
                                                                                                                </GridItem>
                                                                                                            </GridContainer>
                                                                                                        </div>
                                                                                                    )
                                                                                                }
                                                                                            ]}
                                                                                        />

                                                                                    </GridContainer>


                                                                                </GridItem>
                                                                                {/* <GridItem xs={6}>
                                            {this.state.pickUpDate &&
                                              <Button
                                                color="primary"
                                                onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                              >
                                                SEARCH FLIGHTS
                                              </Button>
                                            }


                                          </GridItem>
                                          <GridItem xs={6}>
                                            <Button
                                              color="info"
                                              onClick={() => this.hideFlights()}
                                            >
                                              {this.state.hideFlights ? "SHOW" : "HIDE"} FLIGHTS
                                      </Button>
                                          </GridItem> */}
                                                                                <GridItem xs={12}>
                                                                                    {!this.state.hideFlights &&
                                                                                        <GridContainer>
                                                                                            <GridItem xs={12}>
                                                                                                Flight 1
                                                                                                </GridItem>
                                                                                            {this.props.flight1 && (
                                                                                                <GridItem xs={12}>
                                                                                                    <FlightCard flight={this.props.flight1} isSelected={true} clearFlight={this.props.clearFlight} />
                                                                                                </GridItem>
                                                                                            )}

                                                                                            {this.state.flightNumber === '1' && this.state.matchingFlights.map(flight => (
                                                                                                <GridItem xs={12} onClick={() => this.selectFlight(flight)} >
                                                                                                    <FlightCard flight={flight} isSelected={false} />
                                                                                                </GridItem>
                                                                                            ))}

                                                                                            {(this.state.flightNumber === '2' || (this.props.extraFlights && this.props.extraFlights.length)) ? (
                                                                                                <React.Fragment>

                                                                                                    <GridItem xs={12}>
                                                                                                        Flight 2
                                                                                                        </GridItem>
                                                                                                    {(this.props.extraFlights && this.props.extraFlights.length && ['originAirport', 'number', 'destinationAirport', 'arrivalTime', 'departureTime'].every(v => Object.keys(this.props.extraFlights[0]).includes(v)) && this.props.extraFlights[0].originAirport.length >= 3 && this.props.extraFlights[0].destinationAirport.length >= 3) ? (
                                                                                                        <GridItem xs={12}>
                                                                                                            <FlightCard flight={this.props.extraFlights[0]} isSelected={true} clearFlight={this.props.clearAdditionalLeg} />
                                                                                                        </GridItem>
                                                                                                    ) : null}


                                                                                                    {this.state.flightNumber === '2' && this.state.matchingFlights.map(flight => (
                                                                                                        <GridItem xs={12} onClick={() => this.selectAdditionalLegs(flight)} >
                                                                                                            <FlightCard flight={flight} isSelected={false} />
                                                                                                        </GridItem>
                                                                                                    ))}


                                                                                                </React.Fragment>
                                                                                            ) : null}
                                                                                        </GridContainer>
                                                                                    }

                                                                                </GridItem>
                                                                            </GridContainer>
                                                                            {this.state.searching && <p style={{ color: "black" }}>Loading...</p>}
                                                                        </GridItem>

                                                                    </GridContainer>



                                                                </div>
                                                            }

                                                        </GridItem>
                                                    </GridContainer>
                                                    <br /><br />
                                                    {(pathname == "/completed-orders") ?
                                                        <div>
                                                            <h3 style={{}}><b>Delivery Information</b></h3>
                                CONDITION: <b>{this.state.orderData && this.state.orderData.CONDITION}</b>
                                                            <br />
                                POD: {this.state.orderData &&
                                                                this.state.orderData.BOLPICS.map((item) => (
                                                                    <a style={{ color: "#ff0000 !important" }} href={item} target="_blank">Click here for image</a>
                                                                ))
                                                            }
                                                            <br />
                                                            {
                                                                this.state.orderData &&
                                                                <div>
                                                                    DAMAGE: {this.state.orderData.DAMAGEPIC &&
                                                                        this.state.orderData.DAMAGEPICS.map((item) => (
                                                                            <a style={{ color: "#ff0000 !important" }} href={item} target="_blank">Click here for image</a>
                                                                        ))
                                                                    }
                                                                </div>
                                                            }

                                                        </div>
                                                        :
                                                        null}


                                                </div>
                                                : null}
                                            <br />
                                        </GridItem>
                                    </GridContainer>

                                </form>
                            </div>
                        </GridItem>
                    </GridContainer>

                )}
            </div>
        );
    }
}

Form.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(Form);


// WEBPACK FOOTER //
// ./src/components/Forms/FlightSearchFormNew.jsx